import React, { useEffect } from 'react';
import './SharedPages.css';

function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">Politique de Confidentialité</h1>
          <p className="page-subtitle">
            Nous respectons votre vie privée. Voici comment nous traitons vos données.
          </p>
        </div>

        <div className="page-content">
          <h2>1. Collecte des données</h2>
          <p>
            CrousRadar collecte un minimum de données personnelles nécessaires au bon fonctionnement de l'application (création de compte, pseudonyme, signalements d'affluence).
          </p>

          <h2>2. Utilisation des données</h2>
          <p>
            Les données d'affluence générées par les utilisateurs sont agrégées et anonymisées de manière à fournir des indicateurs de fréquentation aux autres étudiants ainsi qu'aux établissements partenaires.
          </p>

          <h2>3. Protection et Sécurité</h2>
          <p>
            Nous mettons en œuvre toutes les mesures techniques pour protéger vos informations contre l'accès non autorisé, la perte ou l'altération.
          </p>

          <h2>4. Vos Droits</h2>
          <p>
            Conformément au RGPD, vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données qui vous concernent. Pour exercer ce droit, contactez-nous via l'application ou par e-mail à contact@crousradar.fr.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
